import { render, staticRenderFns } from "./VCardImage.vue?vue&type=template&id=e6cb3eb2&"
import script from "./VCardImage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./VCardImage.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./VCardImage.vue?vue&type=style&index=0&id=e6cb3eb2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports